import React, { memo, useContext } from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

import { useState } from "react";
import { withRouter } from "react-router";
import AuthContext from "../../../Context/Auth/AuthContext";
import {
  Cancel,
  CopyAll,
  Create,
  DeleteForever,
  HistoryToggleOff,
  PictureAsPdf,
  Restore,
} from "@mui/icons-material";
import { butonIconTransition, useRowStyles } from "../../../styles/stylesRows";
import { usePermiso } from "../../../hooks/usePermiso";
import { FechaExacta, trimPropsItem } from "../../../config/const";
import ConfirmacionDialog from "../../components/Dialogs/ConfirmacionDialog";
import ButtonsAction from "../../components/Tablas/ButtonsAction";
import CallNombrePersona from "../../components/Tablas/CallNombrePersona";
import clienteAxios from "../../../config/axios";
import AlertaContext from "../../../Context/Alerta/AlertaContext";
import { DialogHistorial } from "./DialogHistorial";
const Row = (props) => {
  // CLASES
  const classes = useRowStyles();
  // PROPS
  const {
    arrayExport,
    setarrayExport,
    row,
    index,
    campoExport,
    seteditar,
    setopen,
    changeObjetoActivoState,
    socket,
    seteditarFactura,
    changeObjetoActivoStateFactura,
    setopenFactura,
    // ObjectoActivoFactura,
  } = props;
  const claseCelda = `${
    index % 2 === 0 ? classes.celda : classes.celdaSecundario
  } ${
    row.editado === true
      ? classes.celdaEditado
      : row.nuevo === true
      ? classes.celdaNuevo
      : row.eliminado === true
      ? classes.celdaEliminado
      : ""
  }`;
  // HOOK DE PERMISO
  const { tienePermiso, alertaPermiso } = usePermiso("Acta_Entrega_Recepcion");
  // CONTEXT
  const { usuario } = useContext(AuthContext);
  const { mostrarAlerta } = useContext(AlertaContext);
  // ABRE EL DIALOG DE CONFIRMACION
  const [openConfirmDialog, setopenConfirmDialog] = useState(false);
  const [openDialogHistorial, setOpenDialogHistorial] = useState(false);
  // STATE`
  const [celComprimida, setcelComprimida] = useState({});
  // ELIMINAR EL REGISTRO
  const handleEliminar = async (_id) => {
    try {
      socket.current.emit("client:eliminarData", {
        tabla: "acta_entrega_recepcion",
        rucempresa: usuario.rucempresa,
        rol: usuario.rol,
        actaUser: usuario.usuario,
        actaEmpresa: usuario.rucempresa,
        [campoExport]: row[campoExport],
      });
      setopenConfirmDialog(false);
    } catch (error) {}
  };
  // FUNCION PARA EDITAR, ABRE EL MODAL COLOCA EN EDITAR EL MODAL Y CAMBIA EL OBJETO ACTIVO
  const funcionEdit = () => {
    setopen(true);
    seteditar(true);
    changeObjetoActivoState(row);
  };
  const funcRecuperar = () => {
    try {
      socket.current.emit(
        "client:guardarData",
        trimPropsItem({
          ...row,

          tabla: "acta_entrega_recepcion",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
          actaUser: usuario.usuario + "/+/" + row[campoExport],
          actaEmpresa: usuario.rucempresa,
          [campoExport]: row[campoExport],
        })
      );

      seteditar(false);
    } catch (error) {}
  };
  return (
    <React.Fragment>
      {openDialogHistorial ? (
        <DialogHistorial
          open={openDialogHistorial}
          setopen={setOpenDialogHistorial}
          row={row}
        />
      ) : null}

      <ConfirmacionDialog
        open={openConfirmDialog}
        setopen={setopenConfirmDialog}
        categoria="warning"
        titulo={`¿Esta seguro de eliminar este registro?`}
        botones={[
          {
            tooltip: "Se eliminaran los registros",
            texto: "SI",
            funcion: () => {
              handleEliminar();
            },
            disabled: false,
            Icon: DeleteForever,
            color: "error",
            id: 1,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: { marginRight: ".3rem" },
          },
          {
            tooltip: "Cancelar",
            texto: "NO",
            funcion: () => {
              setopenConfirmDialog(false);
            },
            disabled: false,
            Icon: Cancel,
            color: "secondary",
            id: 2,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: {},
          },
        ]}
      />
      <TableRow className={classes.root}>
        {/* boton */}
        <ButtonsAction
          claseCelda={claseCelda}
          arrayExport={arrayExport}
          setarrayExport={setarrayExport}
          campoExport={campoExport}
          row={row}
          botones={[
            {
              tooltip: "Recuperar",
              texto: "",
              funcion: () => {
                if (!tienePermiso("agregar")) {
                  return alertaPermiso("agregar");
                }
                funcRecuperar(true);
              },
              disabled: usuario.usuario !== row.actaUser.split("/+/")[0],
              Icon: Restore,
              color: "success",
              id: 3,
              ocultar: !row.eliminado,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
            {
              tooltip: "Editar Registro",
              texto: "",
              funcion: () => {
                if (!tienePermiso("editar")) {
                  return alertaPermiso("editar");
                }
                funcionEdit();
              },
              disabled:
                !(
                  usuario.rol.includes("SUPERADMIN") ||
                  usuario.rol.includes("ADMIN")
                ) &&
                (row.actaEstado === "PROCESADO" ||
                  row.actaEstado === "ANULADO"),
              Icon: Create,
              color: "secondary",
              id: 1,
              ocultar: row.eliminado,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
            {
              tooltip: "Copiar Registro",
              texto: "",
              funcion: () => {
                setopen(true);
                changeObjetoActivoState({
                  ...row,
                  actaFecha: FechaExacta,
                  actaFechaInstalacion: row.actaFechaInstalacion.substr(0, 10),
                });
              },
              disabled: false,
              Icon: CopyAll,
              color: "primary",
              id: 1,
              ocultar: row.eliminado,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
            {
              tooltip: "PDF",
              texto: "",
              funcion: async () => {
                try {
                  window.open(
                    `${clienteAxios.defaults.baseURL}reportes/acta_entrega_recepcion?actaId=${row.actaId}&rucempresa=${row.actaEmpresa}`,
                    "_blank"
                  );
                } catch (error) {
                  console.log({ error });
                  mostrarAlerta("Hubo un error", "error");
                }
              },
              disabled: false,
              Icon: PictureAsPdf,
              color: "error",
              id: 2,
              ocultar: row.eliminado,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
            {
              tooltip: "Eliminar",
              texto: "",
              funcion: () => {
                if (!tienePermiso("eliminar")) {
                  return alertaPermiso("eliminar");
                }
                setopenConfirmDialog(true);
              },
              disabled: false,
              Icon: DeleteForever,
              color: "error",
              id: 3,
              ocultar: true,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
            {
              tooltip: "Ver historial",
              texto: "",
              funcion: () => {
                setOpenDialogHistorial(true);
              },
              disabled: false,
              Icon: HistoryToggleOff,
              color: "primary",
              id: 3,
              ocultar: false,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
          ]}
        />

        <>
          <TableCell
            size="small"
            align="center"
            className={claseCelda}
            onClick={() => {
              if (!tienePermiso("editar")) {
                return alertaPermiso("editar");
              }
              if (
                !(
                  usuario.rol.includes("SUPERADMIN") ||
                  usuario.rol.includes("ADMIN")
                ) &&
                (row.actaEstado === "PROCESADO" || row.actaEstado === "ANULADO")
              ) {
                return;
              }
              funcionEdit();
            }}
            sx={{
              cursor: "pointer",
              color:
                row.actaEstado === "ANULADO"
                  ? "red"
                  : row.actaEstado === "EN PROCESO"
                  ? "blue"
                  : row.actaEstado === "SUSPENDIDO"
                  ? "purple"
                  : row.actaEstado === "PROCESADO"
                  ? "green"
                  : row.actaEstado === "PENDIENTE"
                  ? "orange"
                  : "",
            }}
          >
            {row.actaEstado}
          </TableCell>
          <TableCell size="small" align="center" className={claseCelda}>
            {row.actaId}
          </TableCell>
          <TableCell size="small" align="center" className={claseCelda}>
            {row.actaCiudad}
          </TableCell>
          <TableCell size="small" align="center" className={claseCelda}>
            {row.actaSector}
          </TableCell>
          <TableCell size="small" align="center" className={claseCelda}>
            {`${row.actaDocCliente} ${row.actaNombreCliente}`}
          </TableCell>
          <TableCell size="small" align="center" className={claseCelda}>
            {row.actaTelCliente.join(", ")}
          </TableCell>
          <TableCell size="small" align="center" className={claseCelda}>
            {row.actaTipo}
          </TableCell>
          <TableCell
            size="small"
            align="center"
            className={claseCelda}
            sx={{
              color: row.actaOpcion === "Nueva Instalación" ? "green" : "",
            }}
          >
            {row.actaOpcion}
          </TableCell>
          <TableCell size="small" align="center" className={claseCelda}>
            {row.actaOpcion === "Nueva Instalación"
              ? " - "
              : row.actaServiciosVisita}
          </TableCell>
          <TableCell
            size="small"
            align="center"
            className={claseCelda}
            sx={{
              color:
                row.correo_nuevo_registro === "PENDIENTE"
                  ? "orange"
                  : row.correo_nuevo_registro === "ENVIADO"
                  ? "green"
                  : row.correo_nuevo_registro === "NO ENVIADO" ||
                    row.correo_nuevo_registro === "ERROR"
                  ? "red"
                  : "",
            }}
          >
            {row.correo_nuevo_registro}
          </TableCell>
          <CallNombrePersona user={row.actaUser} claseCelda={claseCelda} />
          <TableCell size="small" align="center" className={claseCelda}>
            {new Date(row.actaFecReg).toLocaleString("es-ES", {
              weekday: "short",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour: "2-digit",
            })}
          </TableCell>
        </>
      </TableRow>
    </React.Fragment>
  );
};

export default withRouter(memo(Row));
